import React, { useEffect, useRef, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import "./Profile.css";
import PropTypes from "prop-types";
import ProspectDetails from "../../Components/ProspectProfile/ProspectDetails";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import generatePDF, { Margin } from "react-to-pdf";
import {
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetUserId,
} from "../../Utils/Utils";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";
import ProspectAiPath from "../../Components/ProspectProfile/ProspectAiPath";
import ProspectNewsFeed from "../../Components/ProspectProfile/ProspectNewsFeed";
import ProspectRequestModal from "../../Components/RequestUpdateModals/ProspectRequestModal";
import MessageModal from "../../Components/MessageModal/MessageModal";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import { Modal, Tab, Tabs, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { ClearIcon } from "@mui/x-date-pickers";
import ExperienceEducationOrganization from "../../Components/ProspectProfile/ExperienceEducationOrganization";
import Prie from "../../Components/ProspectProfile/Prie/Prie";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const Profile = () => {
  const navigate = useNavigate();
  const { id, tab } = useParams();
  let peopleId = id;
  const [loading, setLoading] = useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
  const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
  const [showSalesForce, setShowSalesForce] = useState(false);
  const [archiveRecord, setArchiveRecord] = useState(false);
  const [trackRecord, setTrackRecord] = useState(false);
  const [addToFav, setAddToFav] = useState(false);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [successModel, setSuccessModel] = React.useState("");
  const loggedInUserId = GetUserId();
  const [strengthData, setStrengthData] = useState([]);
  const [eduDetails, setEduDetails] = useState(false);
  const [expDetails, setExpDetails] = useState(false);
  const [shareRecord, setShareRecord] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [organizationData, setOrganizationData] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [trackingData, setTrackingData] = useState([]);
  const [disableTracking, setDisableTracking] = useState(false);
  const [overviewPdfModal, setOverviewPdfModal] = React.useState(false);
  const [downloadSingleTab, setDownloadSingleTab] = React.useState(false);
  const [downloadMultipleTab, setDownloadMultipleTab] = React.useState(false);
  const [value, setValue] = useState(0);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const fetchdata = async () => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_prospect_detail?people_id=${Number(
        peopleId,
      )}`,
    };
    try {
      const response = await axios(options);
      const result = response?.data?.result;
      if (!result || !result.prospect_data?.[0]?.person_id) {
        setMessageModal(true);
      } else {
        getStrength(result);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  const getStrength = async (result) => {
    setLoading(true);

    const tuples = [
      {
        //   items: [1, Number(peopleId)],
        items: [loggedInUserId?.toString(), peopleId?.toString()],
      },
    ];
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/conn_strength`,
    };
    try {
      const response = await axios(options);
      const strengthData = response?.data[0]?.strength;
      setStrengthData(strengthData);

      setProfileData(result.prospect_data[0]);
      if (result.prospect_data[0].suspect_status === null) {
        setShowSalesForce("show");
      }
      setEduDetails(result.edu_details || []);
      setExpDetails(result.exp_details || []);
      setOrganizationData(result.org_data[0]);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchdata();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [peopleId]);
  const handleProspectsPage = () => {
    navigate("/aidecisionmakers");
  };
  const componentRefProfile = useRef();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isCurrentDownloading, setIsCurrentDownloading] = useState(false);
  const handleCurrentProfileDetails = () => {
    const content = componentRefProfile.current;
    const options = {
      filename: "DetailsProfile.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        logging: true,
        letterRendering: true,
        useCORS: true,
      },
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
      // pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf()
      .set(options)
      .from(content)
      .save()
      .then(() => {
        setLoading(false);
        setIsCurrentDownloading(false);
        setOverviewPdfModal(false);
        setDownloadSingleTab(false);
        setDownloadMultipleTab(false);
      })
      .catch(() => {
        setLoading(false);
        setIsCurrentDownloading(false);
        setOverviewPdfModal(false);
        setDownloadSingleTab(false);
        setDownloadMultipleTab(false);
      });
  };
  useEffect(() => {
    if (isCurrentDownloading === true) {
      setLoading(true);
      const timer = setTimeout(() => {
        handleCurrentProfileDetails();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isCurrentDownloading]);
  const handleProfileDetails = () => {
    const content = componentRefProfile.current;
    const options = {
      filename: "DetailsProfile.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        logging: true,
        letterRendering: true,
        useCORS: true,
      },
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf()
      .set(options)
      .from(content)
      .save()
      .then(() => {
        setLoading(false);
        setIsDownloading(false);
        setOverviewPdfModal(false);
        setDownloadSingleTab(false);
        setDownloadMultipleTab(false);
      })
      .catch(() => {
        setLoading(false);
        setIsDownloading(false);
        setOverviewPdfModal(false);
        setDownloadSingleTab(false);
        setDownloadMultipleTab(false);
      });
  };
  useEffect(() => {
    if (isDownloading === true) {
      setLoading(true);
      const timer = setTimeout(() => {
        handleProfileDetails();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isDownloading]);
  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);
  useEffect(() => {
    if (trackingData?.length > 0 && profileData?.person_id) {
      const isMatching = trackingData.some(
        (trackingItem) =>
          Number(trackingItem.person_id) === Number(profileData.person_id),
      );
      setDisableTracking(isMatching);
    } else {
      setDisableTracking(false);
    }
  }, [trackingData, profileData]);
  const handleCheckbox = (type) => {
    if (type === "one") {
      setDownloadSingleTab(true);
      setDownloadMultipleTab(false);
    } else if (type === "two") {
      setDownloadSingleTab(false);
      setDownloadMultipleTab(true);
    }
  };
  const handleClosePdfModal = () => {
    setOverviewPdfModal(false);
  };
  // PRIE CODE HERE
  const [dataForInformation, setDataForInformation] = useState("");

  // const [value, setValue] = React.useState(Number(tab));
  const [isLoadInfoData, setIsLoadInfoData] = useState(false);
  // const [breStatus, setBreStatus] = useState()
  const crieRef = useRef();

  const handleToPDFCrie = () => {
    const content = crieRef.current;
    const options = {
      filename: "OrganizationCrie.pdf",
      margin: 1,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        margin: Margin.MEDIUM,
        format: "letter",
        orientation: "landscape",
      },
    };
    html2pdf().set(options).from(content).save();
  };
  const handlePrint = useReactToPrint({
    content: () => crieRef.current,
    pageStyle: `
      @page {
        size: landscape;
      }
      body {
        -webkit-print-color-adjust: exact; /* Ensure colors print correctly */
      }
    `,
  });
  const newdata = id;
  const informationData = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_prospect_detail?people_id=${Number(
        peopleId,
      )}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setDataForInformation(e?.data?.result?.prospect_data[0]);
          // setBreStatus(e.data.bre);
          localStorage.removeItem("cns");
          localStorage.removeItem("cip");
          localStorage.removeItem("cdp");
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (newdata && isLoadInfoData) {
      informationData();
      // setValue(Number(tab));
    } else {
      setIsLoadInfoData(true);
    }
  }, [newdata, isLoadInfoData]);

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isTabPortrait, setIsTabPortrait] = React.useState(false);
  React.useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );
    const handler = (e) => {
      setIsTabPortrait(e.matches);
    };
    handler(mediaQuery);
    mediaQuery.addEventListener("change", handler);
    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);

  return (
    <Layout>
      {loading ? <Loader /> : null}
      <div className="child-section-of-everypage">
        {!isMobile ? (
          <AiLeadsAction
            setOverviewPdfModal={setOverviewPdfModal}
            profileData={profileData}
            disableTracking={disableTracking}
            setDownloadToPDF={setIsDownloading}
            setIsDecisionMakerExcel={setIsDecisionMakerExcel}
            setIsSalesForceTrigger={setIsSalesForceTrigger}
            showSalesForce={showSalesForce}
            setShareRecord={setShareRecord}
            isSalesForceTrigger={isSalesForceTrigger}
            setRequestUpdateRecord={setRequestUpdateRecord}
            archiveRecord={archiveRecord}
            setArchiveRecord={setArchiveRecord}
            setTrackRecord={setTrackRecord}
            setAddToFav={setAddToFav}
          />
        ) : (
          ""
        )}
        <div
          ref={componentRefProfile}
          // style={{ pageBreakInside: "avoid" }}
        >
          <ProspectDetails
            value={value}
            setValue={setValue}
            strengthData={strengthData}
            setIsSalesForceTrigger={setIsSalesForceTrigger}
            isSalesForceTrigger={isSalesForceTrigger}
            shareRecord={shareRecord}
            setShareRecord={setShareRecord}
            profileData={profileData}
            archiveRecord={archiveRecord}
            fetchdata={fetchdata}
            setArchiveRecord={setArchiveRecord}
            peopleId={peopleId}
            setTrackRecord={setTrackRecord}
            trackRecord={trackRecord}
            addToFav={addToFav}
            setAddToFav={setAddToFav}
            setLoading={setLoading}
            expDetails={expDetails}
            setDisableTracking={setDisableTracking}
            isMobile={isMobile}
            isTabPortrait={isTabPortrait}
          />
          {isMobile ? (
            <div className="p-details-main-lower">
              <Box>
                <Tabs
                  className="mobile-profile-tabs-prie"
                  value={value}
                  onChange={handleChange}
                  aria-label="profile tabs"
                  sx={{
                    minHeight: "auto",
                    "& .MuiTabs-indicator": {
                      display: "none",
                    },
                  }}
                >
                  {/* MAIN RED TAB */}
                  <Tab
                    label="EXPERIENCE | EDUCATION | ORGANIZATION"
                    {...a11yProps(0)}
                    sx={{
                      width: "100%",
                      color: "#9e9e9e",
                      borderRadius: "6px",
                      padding: "10px 0px",
                      fontSize: "12px",
                      fontWeight: 600,
                      minHeight: "auto",
                      marginBottom: "10px",
                      maxWidth: "100%",
                      "&.Mui-selected": {
                        backgroundColor: "#e53935",
                        color: "#fff",
                      },
                    }}
                  />

                  {/* SECONDARY TABS */}
                  <Tab
                    label="PRIE"
                    {...a11yProps(1)}
                    sx={{
                      width: "50%",
                      color: "#9e9e9e",
                      borderRadius: "6px",
                      padding: "10px 0px",
                      fontSize: "12px",
                      fontWeight: 600,
                      minHeight: "auto",
                      "&.Mui-selected": {
                        backgroundColor: "#e53935",
                        color: "#fff",
                      },
                    }} //   textTransform: "uppercase",
                    //   fontSize: "12px",
                    //   fontWeight: 600,
                    //   color: "#9e9e9e",
                    //   minHeight: "auto",
                    //   "&.Mui-selected": {
                    //     color: "#ffffff",
                    //     backgroundColor: "#e53935",
                    //     borderRadius: "5px",
                    //   },
                    // }}
                  />

                  <Tab
                    label="NEWS/EVENTS"
                    {...a11yProps(2)}
                    sx={{
                      width: "50%",
                      //   textTransform: "uppercase",
                      //   fontSize: "12px",
                      //   fontWeight: 600,
                      //   color: "#9e9e9e",
                      //   minHeight: "auto",
                      //   "&.Mui-selected": {
                      //     color: "#ffffff",
                      //     backgroundColor: "#e53935",
                      //   },
                      // }}
                      color: "#9e9e9e",
                      borderRadius: "6px",
                      padding: "10px 0px",
                      fontSize: "12px",
                      fontWeight: 600,
                      minHeight: "auto",
                      "&.Mui-selected": {
                        backgroundColor: "#e53935",
                        color: "#fff",
                      },
                    }}
                  />
                </Tabs>
              </Box>
            </div>
          ) : (
            ""
          )}
          <div
            className="newsfeed-plus-aipath"
            // style={
            //   isDownloading
            //     ? { pageBreakInside: "avoid" }
            //     : { pageBreakInside: "avoid", breakBefore: "page" }
            // }
          >
            {isDownloading ? (
              <>
                <div
                //  style={{ pageBreakInside: "avoid", breakBefore: "page" }}
                >
                  <ExperienceEducationOrganization
                    profileData={profileData}
                    setLoading={setLoading}
                    expDetails={expDetails}
                    eduDetails={eduDetails}
                    organizationData={organizationData}
                    setOrganizationData={setOrganizationData}
                    isDownloading={isDownloading}
                  />
                  <Prie
                    dataForInformation={dataForInformation}
                    handleToPDFCrie={handleToPDFCrie}
                    handlePrint={handlePrint}
                    isDownloading={isDownloading}
                    isMobile={isMobile}
                    isTabPortrait={isTabPortrait}
                  />

                  <ProspectNewsFeed profileData={profileData} />
                </div>
                {/* <div style={{ pageBreakInside: "avoid", breakBefore: "page" }}>
                  <h3>AI Path</h3>
                  <ProspectAiPath
                    profileData={profileData}
                    isDownloading={isDownloading}
                    isCurrentDownloading={isCurrentDownloading}
                  />
                </div> */}
              </>
            ) : (
              <>
                <CustomTabPanel value={value} index={0} className="">
                  <ExperienceEducationOrganization
                    profileData={profileData}
                    setLoading={setLoading}
                    expDetails={expDetails}
                    eduDetails={eduDetails}
                    organizationData={organizationData}
                    setOrganizationData={setOrganizationData}
                    isDownloading={isDownloading}
                    isMobile={isMobile}
                    isTabPortrait={isTabPortrait}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1} className="">
                  <Prie
                    dataForInformation={dataForInformation}
                    handleToPDFCrie={handleToPDFCrie}
                    handlePrint={handlePrint}
                    isDownloading={isDownloading}
                    isMobile={isMobile}
                    isTabPortrait={isTabPortrait}
                  />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2} className="">
                  <ProspectNewsFeed
                    profileData={profileData}
                    isMobile={isMobile}
                    isTabPortrait={isTabPortrait}
                  />
                </CustomTabPanel>
              </>
            )}
          </div>
        </div>
      </div>
      <ProspectRequestModal
        requestUpdateRecord={requestUpdateRecord}
        setRequestUpdateRecord={setRequestUpdateRecord}
        profileData={profileData}
        peopleId={peopleId}
        strengthData={strengthData}
        setSuccessModel={setSuccessModel}
        successModel={successModel}
      />
      <MessageModal
        isMobile={isMobile}
        open={messageModal}
        setOpen={setMessageModal}
        message={
          "No prospect details found. Please check on AI prospects page to find relevant information."
        }
        handleSubmit={handleProspectsPage}
        showBtn={false}
        setSuccessModel={setSuccessModel}
        successModel={successModel}
      />

      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                JOI team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>

      <Modal
        open={overviewPdfModal}
        onClose={handleClosePdfModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-joiTraining-videos"
      >
        <Box sx={style} style={{ overflowY: "auto" }}>
          <div className="box-section-relative">
            <div className="de_pad">
              <h3>Download PDF</h3>
              <div className="checkboxes-optns">
                <div className="inputs-plus-box-dataenrich">
                  <input
                    type="checkbox"
                    checked={downloadSingleTab}
                    onChange={() => handleCheckbox("one")}
                  />
                  <p>Download Current Tab</p>
                </div>
                <div className="inputs-plus-box-dataenrich">
                  <input
                    type="checkbox"
                    checked={downloadMultipleTab}
                    onChange={() => handleCheckbox("two")}
                  />
                  <p>Download All Tabs</p>
                </div>
                <div className="btns-companyprofile-cncl-sumbmit">
                  <button
                    onClick={handleClosePdfModal}
                    className="cancel-btn-companyprofile"
                  >
                    Cancel
                  </button>
                  <button
                    className="downloadpdf-btn-companyprofile"
                    onClick={() => {
                      if (downloadSingleTab) {
                        setIsCurrentDownloading(true);
                      } else if (downloadMultipleTab) {
                        setIsDownloading(true);
                      }
                    }}
                  >
                    Download Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </Layout>
  );
};
export default Profile;
